import { render } from "./Index.vue?vue&type=template&id=cbcc7274"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=cbcc7274&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Customers/PlayerProfile/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cbcc7274"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cbcc7274', __exports__)) {
    api.reload('cbcc7274', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=cbcc7274", () => {
    api.rerender('cbcc7274', render)
  })

}


export default __exports__